import { render, staticRenderFns } from "./OauthCallback.vue?vue&type=template&id=15db6f42&scoped=true"
import script from "./OauthCallback.vue?vue&type=script&lang=js"
export * from "./OauthCallback.vue?vue&type=script&lang=js"
import style0 from "./OauthCallback.vue?vue&type=style&index=0&id=15db6f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db6f42",
  null
  
)

export default component.exports